import { useToast } from '@chakra-ui/react';
import { t } from '@lingui/macro';
import { Api } from 'api';
import { FormControlFormSelect, FormControlFormSelectProps } from 'core';
import React from 'react';
import { useQuery } from 'react-query';
import { CustomerQueryCacheKey } from 'types';

export type ExpertisePackageProps = FormControlFormSelectProps & { expertisePackageGroupId?: string };

export const ExpertisePackageSelect: React.FC<ExpertisePackageProps> = ({
  expertisePackageGroupId,
  ...formSelectProps
}) => {
  const toast = useToast();
  const query = useQuery(
    [CustomerQueryCacheKey.GetExpertisePackagesByGroup, expertisePackageGroupId],
    async () => {
      const response = await Api.Expertise.getExpertisePackagesByGroup(expertisePackageGroupId!);
      const packagesResponse = response.data;
      return packagesResponse.expertisePackageGroup;
    },
    {
      refetchOnWindowFocus: false,
      enabled: !!expertisePackageGroupId,
      onError: (e) => {
        console.error(e);
        toast({
          title: t`Ekspertiz Paketleri Çekilirken Hata Oluştu`,
          status: 'error',
          isClosable: true,
        });
      },
    },
  );
  return (
    <FormControlFormSelect label={t`Ekspertiz Paketi Seç`} placeholder={t`Ekspertiz Paketi Seç`} {...formSelectProps}>
      {query.data?.items.map((expertisePackage) => (
        <option
          value={expertisePackage.expertisePackageId}
          data-price={expertisePackage.price}
          data-campaign-available={query.data?.campaignAvailable ?? false}
          key={`exps${expertisePackage.expertisePackageId}`}
        >
          {expertisePackage.expertisePackageName} - {expertisePackage.price}
        </option>
      ))}
    </FormControlFormSelect>
  );
};
